/**
 * App Store URLs and IDs
 * 
 * Uses environment variables with fallbacks for:
 * - Cloudflare Pages environment variables (production)
 * - Local .env.local (development)
 * - Hardcoded fallback (if env vars not set)
 */

// Phase 1 of the mobile reset: the iOS and Android apps are temporarily delisted from
// the App Store and Play Store while we stabilize on web. While this flag is true, the
// web app should not render install CTAs, App Store badges, or deep-link redirects to
// store URLs (the listings are unavailable). Flip to false in Phase 3 to restore mobile
// promotion in one place. Tracked in #713.
export const MOBILE_APP_PAUSED = true;

// iOS App Store
export const IOS_APP_STORE_ID = process.env.REACT_APP_IOS_APP_STORE_ID || '6749275047';
export const IOS_APP_STORE_URL =
  process.env.REACT_APP_IOS_STORE_URL || `https://apps.apple.com/app/rollops/id${IOS_APP_STORE_ID}`;

// Android Play Store
export const ANDROID_PACKAGE_NAME = process.env.REACT_APP_ANDROID_PACKAGE_NAME || 'com.rollops.rollops';
export const ANDROID_PLAY_STORE_URL =
  process.env.REACT_APP_ANDROID_PLAY_STORE_URL ||
  `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}&pcampaignid=web_share`;



// Google Calendar Booking URL
export const GOOGLE_CALENDAR_BOOKING_URL = process.env.REACT_APP_GOOGLE_CALENDAR_BOOKING_URL || '';
